module.exports = __webpack_public_path__ + "static/media/A-Clubs.4b991c94.svg";